import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
class VendorDocumentGroupResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.documentCode = "";
        this.description = "";
        this.documentName = "";
        this.mustSign = false;
        this.allowMultipleUploads = false;
        this.isDefaultGroup = false;
    }
    pk() {
        return this.documentCode;
    }
}
VendorDocumentGroupResource.urlRoot = legacyApiResourceUrl("DocumentGrid/GetVendorDocumentGroupsJson");
export { VendorDocumentGroupResource };
//# sourceMappingURL=VendorDocumentGroupResource.js.map